import objectPath from 'object-path';
import React, {useMemo} from 'react';
// LayoutContext
import {useHtmlClassService} from '../_core/MetronicLayout';
import {Aside} from './aside/Aside';
import {Footer} from './footer/Footer';
import {LayoutInit} from './LayoutInit';
import {SubHeader} from './subheader/SubHeader';

export function Layout({children}) {
    const uiService = useHtmlClassService();
    // Layout settings (cssClasses/cssAttributes)
    const layoutProps = useMemo(() => {
        return {
            layoutConfig: uiService.config,
            selfLayout: objectPath.get(uiService.config, 'self.layout'),
            asideDisplay: objectPath.get(uiService.config, 'aside.self.display'),
            subheaderDisplay: objectPath.get(uiService.config, 'subheader.display'),
            desktopHeaderDisplay: objectPath.get(
                uiService.config,
                'header.self.fixed.desktop'
            ),
            contentCssClasses: uiService.getClasses('content', true),
            contentContainerClasses: uiService.getClasses('content_container', true),
            contentExtended: objectPath.get(uiService.config, 'content.extended'),
        };
    }, [uiService]);

    return layoutProps.selfLayout !== 'blank' ? (
        <>
            <div className='d-flex flex-column flex-root'>
                <div className='d-flex flex-row flex-column-fluid page'>
                    {layoutProps.asideDisplay && <Aside/>}
                    <div
                        className='d-flex flex-column flex-row-fluid wrapper'
                        id='kt_wrapper'>
                        <div
                            id='kt_content'
                            className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}>
                            {layoutProps.subheaderDisplay && <SubHeader/>}
                            {!layoutProps.contentExtended && (
                                <div className='d-flex flex-column-fluid'>
                                    <div className={layoutProps.contentContainerClasses}>
                                        {children}
                                    </div>
                                </div>
                            )}

                            {layoutProps.contentExtended && {children}}
                        </div>
                        <Footer/>
                    </div>
                </div>
            </div>
            <LayoutInit/>
        </>
    ) : (
        // BLANK LAYOUT
        <div className='d-flex flex-column flex-root'>{children}</div>
    );
}
